"use client";

// src/composite/utils.ts
import { getDocument, isTextField } from "@ariakit/core/utils/dom";
var NULL_ITEM = {
  id: null
};
function flipItems(items, activeId) {
  let shouldInsertNullItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const index = items.findIndex(item => item.id === activeId);
  return [...items.slice(index + 1), ...(shouldInsertNullItem ? [NULL_ITEM] : []), ...items.slice(0, index)];
}
function findFirstEnabledItem(items, excludeId) {
  return items.find(item => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getEnabledItem(store, id) {
  if (!id) return null;
  return store.item(id) || null;
}
function groupItemsByRows(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find(currentRow => {
      var _a;
      return ((_a = currentRow[0]) == null ? void 0 : _a.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function selectTextField(element) {
  let collapseToEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isTextField(element)) {
    element.setSelectionRange(collapseToEnd ? element.value.length : 0, element.value.length);
  } else if (element.isContentEditable) {
    const selection = getDocument(element).getSelection();
    selection == null ? void 0 : selection.selectAllChildren(element);
    if (collapseToEnd) {
      selection == null ? void 0 : selection.collapseToEnd();
    }
  }
}
var FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");
function focusSilently(element) {
  element[FOCUS_SILENTLY] = true;
  element.focus({
    preventScroll: true
  });
}
function silentlyFocused(element) {
  const isSilentlyFocused = element[FOCUS_SILENTLY];
  delete element[FOCUS_SILENTLY];
  return isSilentlyFocused;
}
function isItem(store, element, exclude) {
  if (!element) return false;
  if (element === exclude) return false;
  const item = store.item(element.id);
  if (!item) return false;
  if (exclude && item.element === exclude) return false;
  return true;
}
export { flipItems, findFirstEnabledItem, getEnabledItem, groupItemsByRows, selectTextField, focusSilently, silentlyFocused, isItem };